import React, { useContext } from "react";
import { getNewlyAddedEvents } from "../../actions/eventActions";
import { StoreContext } from "../../Context/StoreContext";
import Button from "../../VibehutUI/Button";
import EventCard from "../../VibehutUI/Card/EventCard";
import Loader from "../../VibehutUI/Loader";

function HomeNewEvents() {
  const { state, dispatch } = useContext(StoreContext);
  const {
    auth: { user },
    event: { newlyAddedEvents, isMore, offset, isFetching, isMoreFetching },
  } = state;

  React.useEffect(() => {
    if (newlyAddedEvents.length === 0) {
      getNewlyAddedEvents(dispatch, user?.token, false, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLoadMore = () => {
    getNewlyAddedEvents(dispatch, user?.token, isMore, offset);
  };
  return (
    <>
      {newlyAddedEvents.length !== 0 && (
        <div className="">
          <div className="block w-full">
            <p className="select-none font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite px-2">
              Newly Added
            </p>
            <p className="select-none font-normal   dark:text-frescoWhite px-2 text-matteGray">
              The most recently added room events, at your fingertips.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-2 3xl:grid-cols-3 grid-cols-1 gap-6 py-6 px-2">
            {newlyAddedEvents
              ? newlyAddedEvents.map((event, index) => (
                  <EventCard
                    event={event}
                    key={index}
                    showRoomLink
                    enableTopMargin={false}
                    showEventTimeLine={true}
                  />
                ))
              : null}
          </div>
          {isFetching ? undefined : !isMoreFetching ? (
            isMore && (
              <div className="flex justify-center pb-5">
                <Button
                  size="vibhut-sm"
                  variant="vibhut-secondary"
                  onClick={handleLoadMore}
                >
                  Load More
                </Button>
              </div>
            )
          ) : (
            <Loader />
          )}
        </div>
      )}
    </>
  );
}

export default HomeNewEvents;
